import QAcomponent from '@/components/general/QAcomponent';
import React, { useState } from 'react';
import styles from '../styles.module.css';
import SectionHead from '@/components/general/SectionHead';

export default function ServiceQA() {
  const [list, setlist] = useState([
    {
      id: 1,
      question: 'چند پلاک می‌توانم ثبت کنم؟',
      answer: 'محدودیتی وجود ندارد؛ می‌توانید همهٔ خودروهای شخصی یا ناوگان خود را اضافه کنید.',
    },
    {
      id: 2,
      question: 'آیا می‌توانم بدهی همهٔ پلاک‌ها را یکجا پرداخت کنم؟',
      answer: 'بله، با پرداخت یکجا تمام بدهی پلاک‌ها در یک تراکنش و با تخفیف تسویه می‌شود.',
    },
    {
      id: 3,
      question: 'پرداخت با کیف پول چه تفاوتی با پرداخت آنلاین دارد؟',
      answer:
        'کیف پول از موجودی حساب کارای شما کسر می‌شود و پرداخت آنلاین به درگاه بانکی متصل است.',
    },
    {
      id: 4,
      question: 'وضعیت گذرنامه به چه معناست؟',
      answer:
        'وضعیت گذرنامه نشان می‌دهد خودرو مجاز به تردد است یا به‌دلیل بدهی یا توقیف محدود شده است.',
    },
  ]);
  return (
    <div className={`${styles.section}`}>
      <div className={`${styles.inner}`}>
        <SectionHead
          title="پاسخ پرسش‌های رایج"
          tag="سوالات متداول"
          type="section"
          // tagClass={`${styles.tagClass}`}
          wrapper={`${styles.wrapper}`}
          // titleClass={`${styles.titleClass}`}
          position="center"
        />
        <QAcomponent list={list} />
      </div>
    </div>
  );
}
